export default __webpack_public_path__ + "static/media/iago.4b3ab46a.png";